import Styles from './styles.module.css';
import React, { useState } from 'react';
import { arrayRemove, arrayUnion, doc, getFirestore, updateDoc } from 'firebase/firestore';
import { useAppSelector } from 'src/salon/app/hook';
import { FaHeart, FaRegHeart } from 'react-icons/fa';

type PostLikeHeartProps = {
  postId: string;
  // 通知の送り先（学生uid = posts.post_uid）
  postUid: string;
  companyLikes: string[];
  onToggled: (nextLikes: string[]) => void;
  // 'overlay'(既定): 画像右下に重ねるハート+件数の表示(info/photoと従来の14.studentWorksの見た目)。
  // 'button': 14.studentWorksのカード下部アクションのように「いいね/いいね済み」の
  // テキストボタンとして表示する。処理・保存先はどちらも共通で変更しない。
  variant?: 'overlay' | 'button';
};

// posts/{postId}.companyLikes に対するサロンいいねの トグルボタン。
// 学生詳細モーダル（info/photo）と学生作品一覧（14.studentWorks）の両方から使う共通部品。
const PostLikeHeart: React.FC<PostLikeHeartProps> = ({ postId, postUid, companyLikes, onToggled, variant = 'overlay' }) => {

  const company = useAppSelector((state) => state.company.company);
  const canLike = company.id !== '';
  const isLiked = companyLikes.includes(company.id);

  const [ pending, setPending ] = useState(false);

  async function handleClick(e: React.MouseEvent) {
    e.stopPropagation();
    if (!canLike || pending) return;

    setPending(true);
    try {
      const db = getFirestore();
      await updateDoc(doc(db, "posts", postId), {
        companyLikes: isLiked ? arrayRemove(company.id) : arrayUnion(company.id),
      });

      const nextLikes = isLiked
        ? companyLikes.filter((id) => id !== company.id)
        : [...companyLikes, company.id];
      onToggled(nextLikes);

      // 「いいね」通知は、Cloud Functions notifyPostLike
      // （posts/{postId}のonUpdate trigger、functions/postLikeNotification.js）が
      // companyLikesの追加を検知してAdmin SDK経由で行う:
      //   - users/{post_uid}/notifications に通知ドキュメントを作成（アプリ内一覧）
      //   - users/{post_uid}.auth.token 宛にFCMプッシュを送信（端末へのプッシュ）
      // Firestore Rulesの notifications createを本人限定に統一するため、
      // client SDKからの直接addDoc()は廃止した。
    } catch (error) {
      console.error("companyLikes update failed:", error);
    } finally {
      setPending(false);
    }
  }

  const isButton = variant === 'button';

  return (
    <div
      className={`${isButton ? Styles.likeButton : Styles.like} ${canLike ? '' : Styles.disabled}`}
      onClick={handleClick}
    >
      {isLiked
        ? <FaHeart className={`${Styles.icon} ${Styles.liked}`} />
        : <FaRegHeart className={Styles.icon} />}
      <span>{isButton ? (isLiked ? 'いいね済み' : 'いいね') : companyLikes.length}</span>
    </div>
  );
};

export default PostLikeHeart;
